import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessCenterService, AUTOMATION_BUSINESS_ENTRY_URL_SERVICE } from '@galaxy/automata/shared';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { SendNotificationFormComponent } from '../../send-notification-common';
import { GenericNotificationID } from '../../send-notification-to-the-user/constants';
import { ASSIGNED_SMBS } from '../../../../../data-services/users.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-send-notification-customers-panel',
  templateUrl: './send-notification-customers-panel.component.html',
  styleUrls: ['./send-notification-customers-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    SendNotificationFormComponent,
  ],
})
export class SendNotificationCustomersPanelComponent extends CommonActionPanelComponent implements OnInit {
  @ViewChild('notificationForm', { static: false })
  sendNotificationForm: SendNotificationFormComponent;
  defaultLinkTemplate$: Observable<string>;

  constructor(
    @Inject(AUTOMATION_BUSINESS_ENTRY_URL_SERVICE) protected readonly businessCenterService: BusinessCenterService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.defaultLinkTemplate$ = this.businessCenterService
      .getVBCEntryUrl()
      .pipe(map((vbcEntryInfo) => vbcEntryInfo.url + '/account/location/{{business_id}}/dashboard'));
    this.savingEnabled = true;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.sendNotificationForm.form];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};

    const notification = this.sendNotificationForm.getData();

    jsonData.notification_id = GenericNotificationID;
    jsonData.notification_channel = notification?.notificationChannel;
    jsonData.user_ids = [ASSIGNED_SMBS];
    jsonData.email_notification = {
      link_template: notification?.emailNotification?.linkTemplate,
      button_text_template: notification?.emailNotification?.buttonTextTemplate,
      subject_template: notification?.emailNotification?.subjectTemplate,
      text_template: notification?.emailNotification?.textTemplate,
    };
    jsonData.in_app_notification = {
      link_template: notification?.inAppNotification?.linkTemplate,
      text_template: notification?.inAppNotification?.textTemplate,
    };

    return jsonData;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  isFormValid(): boolean {
    return this.sendNotificationForm.isFormValid();
  }
}
